import $ from "jquery";

$(function() {
  var triggerOpen = $(".c-overlay-link");
  var triggerClose = $(".c-overlay").find(".c-overlay__close");

  triggerOpen.click(function(e) {
    var overlayItem = $(".c-overlay");
    overlayItem.addClass("is-active");
    $("body").addClass("show-overlay");
    e.preventDefault();
  });

  triggerClose.click(function(e) {
    var overlayItem = $(this).parents(".c-overlay");
    overlayItem.removeClass("is-active");
    $("body").removeClass("show-overlay");
    e.preventDefault();
  });

  $(".c-overlay-link").on("click", function(e) {
    e.preventDefault();
    e.stopPropagation();
  });

  function clickout(e) {
    if (
      !$(".c-overlay").is(e.target) &&
      $(".c-overlay").has(e.target).length === 0
    ) {
      $(".c-overlay.is-active").removeClass("is-active");
      $("body").removeClass("show-overlay");
    }
  }

  $("html body").mousedown(function(e) {
    clickout(e);
  });
});
